var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c(
        "v-expansion-panels",
        { attrs: { multiple: "" } },
        _vm._l(_vm.tables, function(table, tableName) {
          return _c(
            "v-expansion-panel",
            { key: tableName },
            [
              _c(
                "v-expansion-panel-header",
                [
                  _c(
                    "v-layout",
                    {
                      attrs: {
                        row: "",
                        "justify-start": "",
                        "align-center": ""
                      }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("v-checkbox", {
                            attrs: {
                              "input-value": _vm.getSelectAllValueOfGroup(
                                table,
                                tableName
                              ),
                              indeterminate:
                                table.allSelected === "indeterminate",
                              ripple: false,
                              disabled: _vm.disabled || _vm.isViewer,
                              "hide-details": "",
                              color: "accent"
                            },
                            on: {
                              change: function($event) {
                                return _vm.toggleAllOfGroup(table, tableName)
                              },
                              click: function($event) {
                                $event.stopPropagation()
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "12px",
                            color: "rgba(0, 0, 0, 0.54)"
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("permissions.types." + tableName)) +
                              "\n        "
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-expansion-panel-content",
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "px-4 scroll-fire-fox",
                      staticStyle: { overflow: "auto", "box-shadow": "none" },
                      attrs: { "max-height": "250" }
                    },
                    [
                      tableName !== _vm.permissionsAreUnique(tableName)
                        ? _c("table", [
                            _c("thead", [
                              _c(
                                "tr",
                                [
                                  _c("th"),
                                  _vm._v(" "),
                                  _vm._l(table.actionTypes, function(
                                    actionType,
                                    actionTypeName
                                  ) {
                                    return _c(
                                      "th",
                                      {
                                        key: actionTypeName,
                                        staticClass: "px-2"
                                      },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              column: "",
                                              "justify-end": "",
                                              "align-center": ""
                                            }
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "permissions.actionTypes." +
                                                        actionTypeName
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              [
                                                _c("v-checkbox", {
                                                  attrs: {
                                                    "input-value": _vm.getSelectAllValue(
                                                      actionType
                                                    ),
                                                    indeterminate:
                                                      actionType.allSelected ===
                                                      "indeterminate",
                                                    ripple: false,
                                                    disabled:
                                                      _vm.disabled ||
                                                      (_vm.isViewer &&
                                                        !_vm.isAllowedPermissionActionType(
                                                          actionTypeName
                                                        )),
                                                    "hide-details": "",
                                                    color: "accent"
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.toggleAll(
                                                        actionType
                                                      )
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  })
                                ],
                                2
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(table.permissionSets, function(
                                permissionSet,
                                permissionSetName
                              ) {
                                return _c(
                                  "tr",
                                  { key: permissionSetName },
                                  [
                                    _c(
                                      "th",
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            staticClass: "flex-nowrap",
                                            attrs: {
                                              row: "",
                                              "justify-space-between": "",
                                              "align-center": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { shrink: "" } },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "permissions.permissionSets." +
                                                          permissionSetName
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { shrink: "" } },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "ml-4" },
                                                  [
                                                    _c("v-checkbox", {
                                                      attrs: {
                                                        "input-value": _vm.getSelectAllValue(
                                                          permissionSet
                                                        ),
                                                        indeterminate:
                                                          permissionSet.allSelected ===
                                                          "indeterminate",
                                                        ripple: false,
                                                        disabled:
                                                          _vm.disabled ||
                                                          _vm.isViewer,
                                                        "hide-details": "",
                                                        color: "accent"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.toggleAll(
                                                            permissionSet
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm._l(table.actionTypes, function(
                                      actionType,
                                      actionTypeName
                                    ) {
                                      return _c(
                                        "td",
                                        { key: actionTypeName },
                                        [
                                          _c(
                                            "v-layout",
                                            {
                                              attrs: {
                                                "justify-center": "",
                                                "align-center": ""
                                              }
                                            },
                                            [
                                              permissionSet.permissions.hasOwnProperty(
                                                actionTypeName
                                              )
                                                ? _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { top: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var on = ref.on
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  _vm._g(
                                                                    {},
                                                                    on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-checkbox",
                                                                      {
                                                                        attrs: {
                                                                          value:
                                                                            permissionSet
                                                                              .permissions[
                                                                              actionTypeName
                                                                            ],
                                                                          ripple: false,
                                                                          disabled:
                                                                            _vm.disabled ||
                                                                            (_vm.isViewer &&
                                                                              !_vm.isAllowedPermissionActionType(
                                                                                actionTypeName
                                                                              )),
                                                                          "hide-details":
                                                                            "",
                                                                          color:
                                                                            "accent"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.selectedPermissions,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.selectedPermissions = $$v
                                                                          },
                                                                          expression:
                                                                            "selectedPermissions"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "permissions.permissionSets." +
                                                                  permissionSetName
                                                              ) +
                                                                ": " +
                                                                _vm.$t(
                                                                  "permissions.actionTypes." +
                                                                    actionTypeName
                                                                )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "padding-right": "15px"
                                                      }
                                                    },
                                                    [_vm._v("—")]
                                                  )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    })
                                  ],
                                  2
                                )
                              }),
                              0
                            )
                          ])
                        : _c(
                            "table",
                            _vm._l(table.permissions, function(
                              permissionID,
                              permissionName
                            ) {
                              return _c("tr", { key: permissionName }, [
                                _c(
                                  "th",
                                  { staticStyle: { "font-weight": "normal" } },
                                  [
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: {
                                          row: "",
                                          "justify-space-between": "",
                                          "align-center": ""
                                        }
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t(permissionName)) + " "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "ml-4" },
                                          [
                                            _c("v-checkbox", {
                                              attrs: {
                                                value: permissionID,
                                                ripple: false,
                                                disabled:
                                                  _vm.disabled ||
                                                  (_vm.isViewer &&
                                                    ![
                                                      "geoserver",
                                                      "object_forms"
                                                    ].includes(
                                                      permissionName
                                                    ) &&
                                                    _vm.role !== "modules"),
                                                "hide-details": "",
                                                color: "accent"
                                              },
                                              model: {
                                                value: _vm.selectedPermissions,
                                                callback: function($$v) {
                                                  _vm.selectedPermissions = $$v
                                                },
                                                expression:
                                                  "selectedPermissions"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ])
                            }),
                            0
                          )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b4ad28ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4ad28ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SystemManagement/Accounts/Permissions/PermissionsList.vue
// module id = null
// module chunks = 